<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        {{ schoolName }} アカウント一覧
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col ols="3">
            <v-btn class="mb-5 ml-3" small color="#4a81aa" dark @click.stop="create">新規作成</v-btn>
            <v-btn
              class="mb-5 ml-3"
              small
              color="#4a81aa"
              :dark="selected.length > 0"
              :disabled="selected.length === 0"
              @click="generatePassword"
            >パスワード再発行</v-btn>
            <v-btn
              class="mb-5 ml-3"
              small
              dark
              color="#4a81aa"
              @click="allGeneratePassword"
            >一括パスワード再発行</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filterdAccounts"
          :items-per-page="-1"
          show-select
          hide-default-footer
        >
          <template #[`item.subject_code`]="{ item }">
            <v-subject-chip :type="item.subject.code" :style="!item.other_flg ? 'margin-right:37px' : ''">{{ item.subject.name }}</v-subject-chip>
            <span style="opacity:0.5;font-size:11px" v-if="item.other_flg"> その他</span>
          </template>
          <template #[`item.edit`]="{ item }">
            <v-btn icon @click.stop="edit(item)">
              <v-icon small dark>
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </template>
          <template #[`item.delete`]="{ item }">
            <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-base-card>
    <v-confirm-dialog
      ref="confirm"
      title="アカウント削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSubjectChip from '@/components/atoms/SubjectChip'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
    VSubjectChip,
    VConfirmDialog,
  },
  data () {
    return {
      selected: [],
      headers: [
        { text: 'ログインID', align: 'start', value: 'login_id' },
        { text: '学年', align: 'center', value: 'grade', sortable: false },
        { text: '教科', align: 'center', value: 'subject_code', sortable: false },
        { text: '編集', align: 'center', value: 'edit', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      accounts: [],
      selectedGrade: null,
      selectedSubject: null,
      deletedAccount: {
        id: null,
        login_id: '',
      },
    }
  },

  computed: {
    filterdAccounts() {
      return this.accounts
          .filter(accout => { return this.selectedGrade ? accout.grade === this.selectedGrade : accout})
          .filter(accout => { return this.selectedSubject ? accout.subject.name === this.selectedSubject : accout})
    },
    schoolName() {
      return this.$store.state.school.name
    },
    deleteMessage() {
      return `ログインID：${this.deletedAccount.login_id} を削除します。よろしいですか。`
    },
    grades() {
      return this.$store.state.master.allGrades
    },
    subjects() {
      return this.$store.state.master.allSubjects.filter(item => item.ancestryDepth == 0) // 階層が０のもののみ使用する（地歴公民も表示されるので）
    }
  },

  mounted() {
    this.getAccounts()
  },

  methods: {
    // 学校IDに紐付くアカウント一覧を取得
    async getAccounts() {
      const currentSchoolId = this.$store.state.school.id
      const res = await this.$axios.get('/api/v1/admin/teachers?school_id=' + currentSchoolId)

      // 描画用に加工
      res.data.forEach(account =>{
        // 一番若い教科IDの教科マスタ取得
        account.subject = this.subjects.find(subject => subject.id == account.subject_ids[0])
        account.subject_code = account.subject.code
        // 担当教科が複数の場合、「その他」フラグを立てる
        account.subject_ids.length > 1 ? account.other_flg = true : account.other_flg = false

        // 編集用に担当教科の配列を作成
        account.selectedSubjects = []
        account.subject_teachers.forEach(item => {
          const subject_code = this.subjects.find(subject => subject.id == item.subject_id).code
          const grade_code = this.grades.find(grade => grade.id == item.grade_id).code
          account.selectedSubjects.push(subject_code + grade_code)
        })
      })
      this.accounts = res.data
    },
    edit(account) {
      this.$store.commit('account/setAccount', account)
      this.$router.push('/admin/account/')
    },
    create() {
      this.$store.commit('account/initialize')
      this.$router.push('/admin/account')
    },

    openDeleteConfirmDialog(account) {
      this.deletedAccount = account
      this.$refs.confirm.open()
    },
    // アカウント削除API
    async confirmDeletion() {
      const url = `api/v1/admin/teachers/${this.deletedAccount.id}`
      await this.$axios.delete(url)
      this.$toasted.global.success({ message: `ログインID：${this.deletedAccount.login_id} を削除しました` })
      this.getAccounts()
    },

    // パスワード再発行API実行 & パスワード変更アカウント一覧xlsxファイルDL
    async generatePassword() {
      this.$app.$refs.loading.open({message: 'パスワード再発行中です。少々お待ちください。'})
      let params = this.selected.map(x=>{
        return 'ids[]=' + x.id
      }).join('&')
      const res = await this.$axios(`/api/v1/admin/teachers/reset_password.xlsx?${params}`, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.$app.$refs.loading.close()
    },

    // パスワード一括再発行API実行 & パスワード変更アカウント一覧xlsxファイルDL
    async allGeneratePassword() {
      this.$app.$refs.loading.open({message: '一括パスワード再発行中です。少々お待ちください。'})
      const res = await this.$axios(`/api/v1/admin/teachers/all_reset_password.xlsx?school_id=${this.$store.state.school.id}`, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.$app.$refs.loading.close()
    },

    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
